import ReactQuill from "react-quill-new";
import "./assets/css/quill-size.css";

const Quill = ReactQuill.Quill;

const SizeStyle: any = Quill.import("attributors/style/size");
SizeStyle.whitelist = Array.from({ length: 401 }, (_, i) => `${i}px`);

Quill.register(SizeStyle, true);
Quill.register("formats/size", SizeStyle, true);
